import { makeStyles } from '@mui/styles';
import CheckIcon from '@mui/icons-material/Check';

import PeopleItem from '../../PeopleItem';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, palette }) => ({
    root: {
      display: 'flex',
      padding: spacing(2, 1),
      margin: 0,
      textAlign: 'left',
      background: 'transparent',
      width: '100%',
      border: 'none',
      alignItems: 'center',
      '&:hover, &:focus': {
        cursor: 'pointer',
        background: palette.background.alternative,
      },
    },

    item: {
      flexGrow: 1,
      width: '100%',
      overflow: 'hidden',
    },

    check: {
      display: 'flex',
      color: palette.brand.main,
    },
  })
);

export default function PeopleListItem({
  userId,
  userName,
  subHeading,
  avatarUrl = null,
  isSelected = false,
  onClick = () => {},
}) {
  const classes = useStyles();

  return (
    <button type="button" className={classes.root} onClick={onClick}>
      <span className={classes.item}>
        <PeopleItem
          userId={userId}
          userName={userName}
          subHeading={subHeading}
          avatarUrl={avatarUrl}
        />
      </span>
      {isSelected && (
        <span className={classes.check}>
          <CheckIcon color="inherit" />
        </span>
      )}
    </button>
  );
}
